import { STORAGE_KEYS } from '@/constants/storage'
import { WalletContextType } from '@/wallets'

import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

interface ReferralPersistState {
  referralCode: string
  actions: {
    setReferralCode: (referralCode: string) => void
  }
}

const initializePersistData = {
  referralCode: '',
}

export const usePersistReferralStore = create<ReferralPersistState>()(
  persist(
    (set) => ({
      ...initializePersistData,
      actions: {
        setReferralCode: (referralCode) => set({ referralCode }),
      },
    }),
    {
      name: STORAGE_KEYS.REFERRAL,
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({ referralCode: state.referralCode }),
    }
  )
)

export const usePersistReferralActions = () =>
  usePersistReferralStore((state) => {
    const { setReferralCode } = state.actions
    return {
      setReferralCode,
    }
  })
export const usePersistReferralCode = () => usePersistReferralStore((state) => state.referralCode)

export interface WalletOption {
  label: string
  value: string
  wallet: WalletContextType
}

export type ReferralState = {
  referralWallet?: WalletOption
  openClaimModal: boolean
  openConfirmRegister: boolean
  alreadyOpenConfirmRegister: boolean
  claimAmount: number
  actions: {
    setReferralWallet: (wallet: WalletOption) => void
    setOpenClaimModal: (open: boolean, claimAmount?: number) => void
    setOpenConfirmRegister: (open: boolean) => void
  }
}
const initialState = {
  referralWallet: undefined,
  openClaimModal: false,
  openConfirmRegister: false,
  alreadyOpenConfirmRegister: false,
  claimAmount: 0,
}

export const useReferral = create<ReferralState>((set) => ({
  ...initialState,
  actions: {
    setReferralWallet: (wallet: WalletOption) => {
      set({
        referralWallet: wallet,
      })
    },
    setOpenClaimModal: (open: boolean, claimAmount?: number) => {
      set({
        openClaimModal: open,
        claimAmount: claimAmount || 0,
      })
    },
    setOpenConfirmRegister: (open: boolean) => {
      set({
        openConfirmRegister: open,
        alreadyOpenConfirmRegister: true,
      })
    },
  },
}))
export const useReferralActions = () => useReferral((state) => state.actions)
export const useReferralWallet = () => useReferral((state) => state.referralWallet?.wallet)
export const useReferralWalletOption = () => useReferral((state) => state.referralWallet)
export const useOpenClaimModal = () => useReferral((state) => state.openClaimModal)
export const useClaimAmount = () => useReferral((state) => state.claimAmount)
export const useOpenConfirmRegister = () => useReferral((state) => state.openConfirmRegister)
export const useAlreadyOpenConfirmRegister = () => useReferral((state) => state.alreadyOpenConfirmRegister)
